<script>
  import BaseModal from "./BaseModal.svelte";
  import { createEventDispatcher } from "svelte";
  import { openAlertModal } from "../utils/AlertHelper.js";
  import InputCategory from "./InputCategory.svelte";
  import { onMount } from "svelte";
  import StickerImageComponent from "./StickerImageComponent.svelte";

  export let open;
  let latestCategories = [];
  let categories = [];

  let selectedCategory = null;
  let prevCategory;
  let isLatest = latestCategories.length > 0;

  let inputValue = "";
  let title;
  let selectedImage;
  let primaryButtonDisabled = true;

  let deletedMode = false;
  let selectedImages = [];
  let images = [];

  const dispatch = createEventDispatcher();

  function submit() {
    if (selectedImage) {
      dispatch("submit", selectedImage);
    }
  }
  function addCategory() {
    if (categories.length >= 10) {
      openAlertModal({
        width: 400,
        title: "카테고리 초과",
        content:
          "카테고리는 최대 10개까지 추가 가능합니다.<br/>필요없는 카테고리를 삭제해주세요.",
        submit: function (event) {},
      });
      return;
    }
    openAlertModal({
      width: 400,
      title: "스티커 카테고리 추가",
      content: InputCategory,
      contentProps: {
        placeholder: "카테고리 이름을 입력하세요.",
        value: inputValue,
        onChange: (v) => {
          inputValue = v;
        },
      },
      submit: async function (event) {
        if (event.detail) {
          let categoryJson =
            await window.chrome.webview.hostObjects.sync.penChart.postCategory(
              JSON.stringify({ Name: event.detail })
            );
          let category = JSON.parse(categoryJson);
          categories = [category, ...categories];
        }
      },
    });
  }
  function updateCategory(event) {
    if (!event.detail) return;
    let categoryJson =
      window.chrome.webview.hostObjects.sync.penChart.updateCategory(
        JSON.stringify(event.detail)
      );
    const updated = { ...selectedCategory, ...JSON.parse(categoryJson) };
    selectedCategory = updated;
    categories = categories.map((c) => (c.Id === updated.Id ? updated : c));
    console.log(categories, updated);
  }
  function selectCategory(category) {
    selectedCategory = { ...category };
  }
  async function handleDeleteCategory(event) {
    const Id = event.detail.Id;
    await window.chrome.webview.hostObjects.sync.penChart.deleteCategory(
      JSON.stringify({ Id: Id })
    );
    categories = categories.filter((c) => c.Id !== Id);
    selectedCategory = null;
  }
  async function loadCategories() {
    try {
      const jsonStr =
        window.chrome.webview.hostObjects.sync.penChart.getCategories();
      categories = JSON.parse(jsonStr);

      const latestImagesJson =
        window.chrome.webview.hostObjects.sync.penChart.getCategoryImagesLatest();
      latestCategories = JSON.parse(latestImagesJson);
      isLatest = latestCategories.length > 0;

      for (const category of latestCategories) {
        if (category.isDefault) {
          window.chrome.webview.hostObjects.sync.penChart.downloadDefaultImage(
            "onBase64Chunk",
            category.Id,
            category.ThumbnailUBRSPath
          );
        } else {
          window.chrome.webview.hostObjects.sync.penChart.downloadImage(
            "onBase64Chunk",
            category.Id,
            category.ThumbnailUBRSPath
          );
        }
      }
    } catch (err) {
      console.log(err);
      // openAlertModal({
      //   title: "오류",
      //   content: "카테고리를 불러오는 데 실패했습니다.",
      // });
    }
  }
  onMount(() => {
    loadCategories();
  });

  $: title = selectedCategory?.Name ?? "스티커";
  $: if (open == false) {
    initCategoryList();
  } else if (open == true) {
    loadCategories();
  }
  $: primaryButtonDisabled = selectedImage == null;
  $: if (selectedCategory !== prevCategory) {
    selectedImage = null;
    prevCategory = selectedCategory;
  }

  window.addEventListener("image-blob-ready", (e) => {
    const { id, ...imageMeta } = e.detail;
    latestCategories = latestCategories.map((c) =>
      c.Id === id ? { ...c, thumbFile: { ...imageMeta } } : c
    );
  });

  function handleSelectForDelete(event) {
    selectedImages = event.detail.selectedImages;
  }

  async function handleDeleteImages() {
    if (selectedImages.length > 0 && selectedCategory) {
      openAlertModal({
        width: 400,
        title: "삭제하기",
        content: `${selectedImages.length}장의 스티커를 정말로 삭제하시겠어요?`,
        submit: async function (event) {
          await window.chrome.webview.hostObjects.sync.penChart.deleteCategoryImages(
            selectedCategory.Id,
            JSON.stringify(selectedImages)
          );
          images = images.filter((image) => !selectedImages.includes(image.Id));
          selectedImages = [];
          deletedMode = false;
        },
      });
    }
  }

  function initCategoryList() {
    title = "스티커";
    deletedMode = false;
    selectedImages = [];
    selectedCategory = null;
    selectedImage = null;
  }
</script>

<BaseModal
  width={556}
  bind:show={open}
  onClose={() => (open = false)}
  bind:title
  disableOverlayClose={true}
  bind:primaryButtonDisabled
  on:submit={submit}
>
  {#if selectedCategory == null}
    <div class="category-section">
      {#if isLatest}
        <div class="latest-section">
          <div class="latest-title">최근 사용</div>
          <div class="latest-list">
            {#each latestCategories as image}
              <div
                class="latest-item"
                class:active={image.Id === selectedImage?.Id}
                on:click={() => (selectedImage = image)}
              >
                {#if image.thumbFile}
                  <img src={image.thumbFile.url} class="latest-item-img" />
                {:else}
                  <div>로딩 중...</div>
                {/if}
              </div>
            {/each}
          </div>
          <div class="latest-divider"></div>
        </div>
      {/if}
      <div class="category-list-section">
        <div class="category-title">카테고리</div>
        <div class="category-list">
          {#each categories as category, i}
            <div class="category-item" on:click={selectCategory(category)}>
              <span class="category-icon"
                ><svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="36" height="36" rx="18" fill="#828691" />
                  <path
                    d="M14.5381 10.7998C15.2256 10.7998 15.5697 10.7999 15.8828 10.9209C16.1961 11.042 16.451 11.2737 16.96 11.7363L17.9102 12.5996H26.0996C26.5967 12.5996 27 13.0029 27 13.5V24.2998C27 24.7969 26.5967 25.2002 26.0996 25.2002H9.90039C9.40333 25.2002 9 24.7969 9 24.2998V13.5L9.00195 12.9443C9.00838 12.4572 9.03399 12.1592 9.13672 11.9111C9.3194 11.4701 9.67029 11.1202 10.1113 10.9375C10.4421 10.8005 10.8615 10.7998 11.7002 10.7998H14.5381Z"
                    fill="white"
                  />
                </svg>
              </span>
              <span class="category-name">{category.Name}</span>
            </div>
          {/each}

          <div class="category-item" on:click={addCategory}>
            <span class="category-icon"
              ><svg
                width="36"
                height="36"
                viewBox="0 0 36 36"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="0.9"
                  y="0.9"
                  width="34.2"
                  height="34.2"
                  rx="17.1"
                  fill="white"
                />
                <rect
                  x="0.9"
                  y="0.9"
                  width="34.2"
                  height="34.2"
                  rx="17.1"
                  stroke="#C1C1C1"
                  stroke-width="1.8"
                />
                <path
                  d="M12.1499 17.6688H23.8499M18.1063 12.1499V23.8499"
                  stroke="#C1C1C1"
                  stroke-width="1.8"
                  stroke-linecap="round"
                />
              </svg>
            </span>
            <span class="category-name">카테고리 추가</span>
          </div>
        </div>
      </div>
    </div>
  {:else}
    <div class="sticker-section">
      <StickerImageComponent
        bind:category={selectedCategory}
        bind:images
        bind:selectedImages
        bind:selectedImage
        bind:deletedMode
        on:back={initCategoryList}
        on:updateCategory={updateCategory}
        on:deleteCategory={handleDeleteCategory}
        on:selectForDelete={handleSelectForDelete}
      ></StickerImageComponent>
    </div>
  {/if}
  <div slot="footer">
    {#if deletedMode && selectedImages.length > 0}
      <button
        class="cancel-btn"
        on:click={() => (
          (deletedMode = false), (selectedImages = []), (selectedImage = null)
        )}>취소</button
      >
      <button class="danger-btn" on:click={handleDeleteImages}>삭제</button>
    {:else}
      <button
        class="confirm-btn"
        disabled={primaryButtonDisabled}
        on:click={submit}>확인</button
      >
    {/if}
  </div>
</BaseModal>

<style scoped>
  .category-title {
    font-weight: 500;
    font-size: 16px;
    color: #1d2226;
    margin-bottom: 12px;
  }
  .category-list {
    max-height: 386px;
  }
  .category-item {
    width: 516px;
    height: 61px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #e0e0e0;
    gap: 20px;
    cursor: pointer;
  }
  .category-item:hover {
    background: #f5f7fa;
  }
  .category-item:last-child {
    border-bottom: none;
  }
  .category-name {
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: #1d2226;
    letter-spacing: 0;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .latest-section {
    margin-bottom: 12px;
  }
  .latest-title {
    font-weight: 500;
    font-size: 16px;
    color: #1d2226;
    margin-bottom: 12px;
  }
  .latest-list {
    display: flex;
    gap: 12px;
    margin-bottom: 20px;
  }
  .latest-item {
    width: 120px;
    height: 120px;
    background: #eaecef;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    border: 1px solid #eaeaea;
  }
  .latest-item-img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    display: block;
    margin: auto;
  }
  .latest-item.active {
    border: 3px solid #3b5998;
  }
  .latest-divider {
    border-bottom: 1px solid #e0e0e0;
    margin: 0 0 16px 0;
  }
  .category-list-section {
    min-height: 457px;
  }
  .sticker-section {
    min-height: 457px;
  }
  .custom-footer {
    background: #f0f3f9;
    border-top: 1px solid #e5e5e5;
    display: flex;
    justify-content: flex-end;
    height: 54px;
    padding: 12px 20px;
    gap: 8px;
  }
  .cancel-btn {
    background: #fff;
    color: #1d2226;
    border: 1px solid #e0e0e0;
    border-radius: 2px;
    padding: 0 24px;
    font-size: 12px;
    font-weight: 400;
    height: 30px;
    line-height: 30px;
    cursor: pointer;
  }
  .danger-btn {
    background: #ff5252;
    color: #fff;
    border: none;
    border-radius: 2px;
    padding: 0 24px;
    font-size: 12px;
    font-weight: 700;
    height: 30px;
    line-height: 30px;
    cursor: pointer;
    margin-left: 12px;
  }
  .danger-btn:hover {
    background: #e23c3c;
  }
  .confirm-btn {
    background: #3b5998;
    color: #fff;
    border-radius: 2px;
    padding: 0px 24px;
    font-size: 12px;
    font-weight: 700;
    cursor: pointer;
    height: 30px;
    line-height: 30px;
  }
  .confirm-btn:hover {
    background: #1b3e8a;
  }
  .confirm-btn:disabled {
    background: #bfc8d7;
    color: #fff;
    cursor: not-allowed;
    opacity: 0.7;
  }
</style>
